import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

const styles: ComponentStylesProps<string> = {
  titleSection: {
    paddingBottom: '3rem',
    marginBottom: '3rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  title: (size) => ({
    color: colors.neutral[900],
    margin: '0 0 1rem',
    fontSize: size === 'LARGE' ? '2rem' : '1.6rem',
    lineHeight: size === 'LARGE' ? '2.8rem' : '2.4rem',
    letterSpacing: '0.0225em',
  }),
  subtitle: {
    color: colors.neutral[700],
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    margin: 0,
    letterSpacing: '0.02em',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
